import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import Layout from './layouts/Layout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useSession } from 'hooks/useAuthentication';
import { Suspense } from 'react';

// eslint-disable-next-line react/prop-types
export function AuthFetcher({ children }) {
  useSession();
  return <>{children}</>;
}
const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthFetcher>
        <Router basename={process.env.PUBLIC_URL}>
          <Suspense fallback={<div>Loading</div>}>
            <Layout />
          </Suspense>
        </Router>
      </AuthFetcher>
    </QueryClientProvider>
  );
};

export default App;
